import styles from "./PageTitle.module.scss";
import PageTitleType from "./PageTitleType";

const PageTitle = (props: PageTitleType) => {
  const {id,text,commonClass} = props;
  return (
    <>
      <h1 className={`${styles.PageTitle}`} id={id}>
        {text}
      </h1>
    </>
  )
}
export default PageTitle;